var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`pl-${ _vm.spacing[_vm.nutrient] * 4 }`},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.keyToLabelHtml(_vm.nutrient))}}),_c('span',{domProps:{"innerHTML":_vm._s("&nbsp;")}}),_c('span',{staticClass:"font-weight-black"},[_vm._v(_vm._s(_vm.keyToUnit(_vm.nutrient)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }